/*

	TODO:veevalidate4に対応した記述に修正する。
	
	vee-validateについて
	https://logaretm.github.io/vee-validate/guide/basics.html

	- ルールの追加方法
		使用するルールを以下の「ルールの追加」部に記載する。

	- カスタムルールの追加方法
		以下の「カスタムルールの追加」部に記載する。

	- メッセージの追加方法
		src/assets/messages/validationMsg.jsonのmessagesに追加する。
		フィールド名(例： ログインID)を追加する場合は、validationMsg.jsonのfieldに追加する。
	
	- 使用例
		TODO:
*/
//import Vue from 'vue'
import { Form, Field, ErrorMessage, defineRule, configure } from 'vee-validate';
//import { required, email, min, max, min_value, max_value, confirmed } from '@vee-validate/rules/dist/vee-validate-rules';
import { required, email, min, max, min_value, max_value, confirmed } from '@vee-validate/rules';
//import { i18n } from './i18n'
import { localize } from '@vee-validate/i18n';
import { setLocale } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
//import { defineRule } from 'vee-validate';

let msg = {
	en,
	ja,
};

// メッセージ設定
configure({
	generateMessage: localize(msg)
});
defineRule('required', required);
defineRule('email', email);
defineRule('min', min);
defineRule('max', max);
defineRule('min_value', min_value);
defineRule('max_value', max_value);
defineRule("confirmed", confirmed);

const customValidator = (value, params) => {
	if(!params.validate(value)){
		return params.message;
	}
	return true;
};
defineRule('custom', customValidator);

// グローバル登録
export default (app, i18n) => {
	app.component("Form", Form);//eslint-disable-line
	app.component("Field", Field);//eslint-disable-line
	app.component("ErrorMessage", ErrorMessage);
	setLocale(i18n.global.locale.value);
}
